import { createSelector } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';

export const selectRouterState = (state: {
  router: fromRouter.RouterReducerState;
}) => state.router;

export const selectRouter = createSelector(
  selectRouterState,
  (state) => state || '',
);
export const selectNavigationId = createSelector(
  selectRouterState,
  (state) => state?.navigationId,
);

export const {
  selectUrl, // select the current url
} = fromRouter.getRouterSelectors(selectRouter);
